module.exports = __webpack_public_path__ + "static/img/xibeimeng_icon.baa2678.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/shop_img_icon/xibeimeng_icon.png
// module id = nqaA
// module chunks = 1